module.exports = __webpack_public_path__ + "img/ic_download.8c850972.svg";